import { render, staticRenderFns } from "./OutlinedBlock.vue?vue&type=template&id=e85ffffa&scoped=true&"
import script from "./OutlinedBlock.vue?vue&type=script&lang=js&"
export * from "./OutlinedBlock.vue?vue&type=script&lang=js&"
import style0 from "./OutlinedBlock.vue?vue&type=style&index=0&id=e85ffffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85ffffa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VInput,VSheet})
